
export enum PartyRoleCd {
	INBOUND = 'Inbound',
	INBOUND_AND_OUTBOUND = 'InboundAndOutbound',
	OUTBOUND = 'Outbound',
	THIRD_PARTY = 'ThirdParty'}

